import React from "react";
import { STATUS } from "../utils/constants";

/**
 * Mobile card view component for product availability
 * Displays products in a card layout optimized for mobile devices
 */
const MobileCardView = ({ products, currencySymbol }) => {
  /**
   * Get status text color class
   * @param {string} status - Product status
   * @returns {string} Tailwind CSS class
   */
  const getStatusColorClass = (status) => {
    const isAvailable = status === STATUS.AVAILABLE;
    return isAvailable ? "text-green-600" : "text-red-600";
  };

  /**
   * Format price with currency symbol
   * @param {number|string} price - Price value
   * @returns {string} Formatted price
   */
  const formatPrice = (price) => {
    return price !== "-" ? `${currencySymbol}${price}` : "-";
  };

  if (products.length === 0) {
    return (
      <div className="p-8 text-center bg-white rounded-lg shadow-sm">
        <p className="text-gray-500">No products found.</p>
      </div>
    );
  }

  return (
    <div className="pb-4">
      {products.map((item) => (
        <div
          key={item.id}
          className="mb-4 rounded-lg shadow-md border border-gray-200 bg-white transition-shadow hover:shadow-lg"
        >
          <div className="p-4">
            {/* Product Number Badge */}
            <div className="mb-2">
              <span className="inline-block bg-blue-600 text-white text-xs font-semibold px-3 py-1 rounded-full">
                {item.productNumber}
              </span>
            </div>

            {/* Product Name */}
            <h3 className="text-lg font-semibold text-blue-600 mb-3">
              {item.productName}
            </h3>

            {/* Category Info */}
            <div className="flex gap-4 mb-2 flex-wrap">
              <p className="text-sm text-gray-600">
                <strong>Category:</strong> {item.categoryName}
              </p>
              <p className="text-sm text-gray-600">
                <strong>Sub:</strong> {item.subcategoryName}
              </p>
            </div>

            <hr className="my-3 border-gray-200" />

            {/* Prices Grid */}
            <div className="grid grid-cols-2 gap-4 mb-3">
              <div>
                <p className="text-xs text-gray-600 mb-1">Price</p>
                <p className="text-xl font-semibold text-green-600">
                  {formatPrice(item.price)}
                </p>
              </div>
              <div>
                <p className="text-xs text-gray-600 mb-1">Offer Price</p>
                <p className="text-xl font-semibold text-red-600">
                  {formatPrice(item.offerPrice)}
                </p>
              </div>
            </div>

            <hr className="my-3 border-gray-200" />

            {/* Status Badge */}
            <div className="flex justify-center">
              <span
                className={`text-lg font-bold ${getStatusColorClass(item.status)}`}
              >
                {item.status}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MobileCardView;
